import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import { QRCodeCanvas } from 'qrcode.react';
import { FaDownload, FaCopy, FaCheck } from "react-icons/fa6";

function QRCodeModal({ show, handleClose, team, season }) {
    const [registrationUrl, setRegistrationUrl] = useState('');
    const [copySuccess, setCopySuccess] = useState(false);
    const qrRef = useRef(null);

    useEffect(() => {
        if (show && team && season) {
            // Construct the registration URL
            const baseUrl = window.location.origin;
            const url = `${baseUrl}/league/${season}/${team.id}/register/`;
            setRegistrationUrl(url);
        }
    }, [show, team, season]);

    const handleDownload = () => {
        if (qrRef.current) {
            const canvas = qrRef.current.querySelector('canvas');
            if (canvas) {
                const pngUrl = canvas.toDataURL('image/png');
                const downloadLink = document.createElement('a');
                downloadLink.href = pngUrl;
                downloadLink.download = `${team.name}-registration-qr.png`;
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            }
        }
    };

    const handleCopyLink = async () => {
        try {
            await navigator.clipboard.writeText(registrationUrl);
            setCopySuccess(true);
            setTimeout(() => setCopySuccess(false), 2000);
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Team Registration QR Code</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center">
                {registrationUrl && (
                    <>
                        <div className="mb-3" ref={qrRef}>
                            <QRCodeCanvas
                                value={registrationUrl}
                                size={256}
                                level="H"
                                includeMargin={true}
                                bgColor="#ffffff"
                                fgColor="#000000"
                            />
                        </div>
                        <p className="text-muted mb-3">
                            Scan this QR code to register for {team.name}
                        </p>
                        <div className="d-flex justify-content-center gap-2">
                            <Button
                                variant="outline-primary"
                                onClick={handleDownload}
                                className="d-flex align-items-center gap-2"
                            >
                                <FaDownload /> Download
                            </Button>
                            <Button
                                variant="outline-primary"
                                onClick={handleCopyLink}
                                className="d-flex align-items-center gap-2"
                            >
                                {copySuccess ? <FaCheck /> : <FaCopy />}
                                {copySuccess ? 'Copied!' : 'Copy Link'}
                            </Button>
                        </div>
                        {copySuccess && (
                            <Alert variant="success" className="mt-3 mb-0 py-2">
                                Registration link copied to clipboard!
                            </Alert>
                        )}
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default QRCodeModal; 